import React from "react";
import { getStandaloneComponentRenderer } from "@kaltura/mediaspace-shared-layout";

const BulkLoginLinks = React.lazy(() => import("@mediaspace/features/bulk-login-links"));

export const render = getStandaloneComponentRenderer(BulkLoginLinks);
